import React, {Component} from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "react-bootstrap";
import RemotingService from "../../../services/remoting-service/RemotingService";
import AuthService from "../../../services/auth-service/AuthService";
import confirmDialog from "../../../components/dialog/ConfirmDialog";
import confirmAndDeleteDialog from "../../../components/dialog/ConfirmAndDeleteDialog";

class AppointmentNotes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            notes: this.props.appointment.notes
        };
    }

    isAppointmentStatusStartable(status) {
        return status === "BOOKED" || status === "CONFIRMED" || status === "ARRIVED";
    }

    openLinkInNewTab = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    render() {
        return (
            <fieldset style={{padding: "20px", border: "3px solid #CCC"}}>
                <legend style={{width: "auto", padding: "0 10px"}}>Notes</legend>
                {this.props.appointment.teleconsultationUrl &&
                    <Button variant="success" style={{marginBottom: '3px'}}
                            disabled={!AuthService.isFromManagement() && (this.state.index !== this.props.currentVisitIndex
                                || AuthService.getUser().name !== this.props.appointment.staff.name)}
                            onClick={() => {
                                if (this.isAppointmentStatusStartable(this.props.appointment.status)) {
                                    confirmDialog("Alert",
                                        "Do you also want to start the visit?",
                                        () => {
                                            this.startAppointment(this.props.appointment.id);
                                        },
                                        () => this.openLinkInNewTab(this.props.appointment.teleconsultationUrl), null, "Yes", "No");
                                } else {
                                    this.openLinkInNewTab(this.props.appointment.teleconsultationUrl);
                                }
                            }}
                    >{'  Teleconsult '}</Button>
                }
                <DataTable value={this.state.notes}
                           emptyMessage={<div style={{textAlign: "center"}}>There are no notes.</div>}>
                    {/*<Column field="id" header="ID" sortable={true} style={{ width: "50px" }} />*/}
                    <Column field="text" header="Text" style={{minWidth: "150px"}}/>
                    <Column field="staffName" header="Added By" sortable={true} style={{width: "125px"}}/>
                    {/*<Column field="creationDate" header="Creation Time" sortable={true} style={{ width: "200px" }} />*/}
                    {/*<Column field="updateDate" header="UPDATE TIME" sortable={true} style={{ width: "200px" }} />*/}
                    <Column field="state" header="Status" sortable={true} style={{width: "75px"}}/>
                    <Column header="" body={this.openDoneActionTemplate} style={{width: "100px"}}/>
                    <Column header="" body={this.deleteActionTemplate} style={{width: "80px"}}/>
                </DataTable>
            </fieldset>
        );
    }

    openDoneActionTemplate = (rowData) => {
        if (!AuthService.userHasAuthority("ADD_APPOINTMENT_NOTE")) {
            return null;
        }
        let action = (rowData.state === "OPEN") ?
            <Button style={{fontSize: 11}} variant="outline-secondary" onClick={() => this.setNoteAsDone(rowData.id)}>Set
                As Done</Button> :
            <Button style={{fontSize: 11}} variant="outline-primary" onClick={() => this.setNoteAsOpen(rowData.id)}>Set
                As Open</Button>;

        return (<div style={{position: 'relative', float: 'right'}}> {action} </div>);
    };

    deleteActionTemplate = (rowData) => {
        if (!AuthService.userHasAuthority("ADD_APPOINTMENT_NOTE")) {
            return null;
        }
        let action = <Button style={{fontSize: 11}} variant="outline-danger"
                             onClick={() => this.deleteNote(rowData.id)}>Delete</Button>;
        return (rowData.state === "OPEN") ? (
            <div style={{position: 'relative', float: 'right'}}> {action} </div>) : null;
    };

    deleteNote = (noteId) => {
        confirmAndDeleteDialog(
            "Delete Note",
            "Are you sure you want to delete this note? This action cannot be undone.",
            '/api/appointment/note/' + noteId,
            this.refreshNotes
        );
    };

    setNoteAsDone = (noteId) => {
        RemotingService.postRemoteCall('/api/appointment/note/' + noteId + '/done', null, this.refreshNotes);
    };

    setNoteAsOpen = (noteId) => {
        RemotingService.postRemoteCall('/api/appointment/note/' + noteId + '/open', null, this.refreshNotes);
    };

    refreshNotes = () => {
        RemotingService.getRemoteCall('/api/appointment/' + this.props.appointment.id + '/note', null, (notes) => {
            this.props.onRefreshNotes(notes);
            this.setState({notes});
        });
    };

    startAppointment(appointmentId) {
        RemotingService.postRemoteCall(`api/appointment/${appointmentId}/start`, null, () => {
            this.props.onAppointmentStarted();
            this.openLinkInNewTab(this.props.appointment.teleconsultationUrl);
        });
    }
}

export default AppointmentNotes;